import styled from 'styled-components'

export const ActionLinksWrapper = styled.div`
  position: absolute;
  right: 37px;
  top: -10px;
  & > {
    margin-left: 15px;
  }
  .button-delete {
    display: block;
    position: relative;
    float: left;
  }
  & > * {
    margin: 0 20px 0 0;
  }

  & > *:last-child {
    margin: 0px 0px 0 16px;
  }

  .unbook-button {
    float: right;
  }
`



// WEBPACK FOOTER //
// ./src/Containers/Mission/Header/ActionLinks/style.js